import cn from 'classnames';
import { forwardRef } from 'react';

import { useSurveyStyle } from '@webapp/common/components/custom-styles';
import { isPreview } from '@webapp/common/lib/const';
import { isEmbedded } from '@webapp/common/lib/ua';

import { selectInfo } from '@webapp/survey/src/machine/selectors';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';

import styles from './survey.css';

export const ViewWrapper = forwardRef<HTMLDivElement, { children: ReactNode }>(({ children }, ref) => {
    const {
        design,
        params: {
            other: { disallowTextCopy },
        },
    } = useStateSelector(selectInfo);
    const surveyStyles = useSurveyStyle(design, isPreview);

    return (
        <div
            ref={ref}
            style={surveyStyles}
            className={cn(styles.survey, 'survey', {
                [styles.embedded]: isEmbedded,
                [styles.noSelection]: disallowTextCopy,
            })}
        >
            {children}
        </div>
    );
});
